<template>
  <li class="color-item">
    <div class="color-item__number">{{ index + 1 }}</div>
    <a
      href="javascript:void(0)"
      :id="`${id}_popover`"
      class="color-item__color"
      :style="{ background: color }"
    />

    <b-form-select
      v-if="selectIsActive"
      v-model="selected"
      class="select"
      :options="tagList"
      @change="changeTagHandler"
    >
    </b-form-select>

    <b-popover
      :target="`${id}_popover`"
      triggers="click blur"
      placement="right"
      ref="popover"
    >
      <ColorPicker
        :colors="colorsPallet"
        @onSelectColor="onChangeColor"
      />
    </b-popover>
  </li>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker.vue';
import { TAG_LIST } from '../../common/constants';

export default {
  name: 'PatchColorItem',
  components: {
    ColorPicker
  },

  data () {
    return {
      selected: this.selectedTag,
      tagList: TAG_LIST
    };
  },

  props: {
    id: String,
    layerId: String,
    color: String,
    colorId: Number,
    index: Number,
    colorIdByTextPatch: Number,
    material: String,
    selectedTag: String,
    selectIsActive: Boolean
  },

  computed: {
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
    colorsPallet () {
      let pallet;
      if (this.material) {
        if (this.material === 'chenille') {
          pallet = this.colorsCategories.textColors;
        } else {
          pallet = this.colorsCategories.patchColors;
        }
      }

      if (!this.material && this.id.includes('patch')) {
        if (this.colorId === 0 || this.colorId === 1) {
          pallet = this.colorsCategories.patchColors;
        } else {
          pallet = this.colorsCategories.textColors;
        }
      }

      if (!this.material && this.id.includes('insert')) {
        if (this.colorId === 0) {
          pallet = this.colorsCategories.patchColors;
        } else {
          pallet = this.colorsCategories.textColors;
        }
      }

      return pallet;
    }
  },

  methods: {
    onChangeColor (newColor) {
      this.$emit('onChangeColor', newColor, this.layerId, this.colorIdByTextPatch);
      this.$refs.popover.$emit('close');
    },

    changeTagHandler (data) {
      this.$emit('onChangeTag', this.layerId, data);
      console.log('data: ', data);
    }
  }
};
</script>

<style scoped>
.color-item {
  align-items: center;
  border-top: 1px solid #ffffff;
  height: 40px;
  display: flex;
  list-style: none;
}

.color-item__number {
  text-align: center;
  width: 40px;
}

.color-item__color {
  flex: 1;
  display: flex;
  min-width: 60px;
  height: 100%;

  cursor: pointer;
}

.color-item__color--disabled {
  position: relative;

  border: 2px dashed #000;

  pointer-events: none;

  &::after {
    content: "";

    position: absolute;
    left: 0;
    top: 0;

    display: block;
    width: 100%;
    height: 100%;

    background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 49.9%, rgba(28, 6, 6, 0.8) 49.9%,
    rgba(28, 6, 6, 0.8) 60%, rgba(255, 255, 255, 0.1) 60% ),
    linear-gradient(45deg, rgba(28, 6, 6, 0.8) 10%, rgba(255, 255, 255, 0.1) 10% );
    background-size: 0.5em 0.5em;
  }
}

.color-item select {
  width: 140px;
}
</style>
